<template>
	<modal name="login-registration-force" :width="300" height="auto" :click-to-close="false">
		<LoginRegistrationModalContent init-tab="registration" />
	</modal>
</template>

<script>
	import LoginRegistrationModalContent from "./LoginRegistrationModalContent";
	export default {
		name: "LoginRegistrationForceModal",
		components: {LoginRegistrationModalContent}
	}
</script>

